import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("davide_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("davide_email"));

  useEffect(() => {
    if (token) localStorage.setItem("davide_token", token);
    else localStorage.removeItem("davide_token");
    if (email) localStorage.setItem("davide_email", email);
    else localStorage.removeItem("davide_email");
  }, [token, email]);

  const login = async (em, pw) => {
    const { data } = await api.post("/auth/login", { email: em, password: pw });
    setToken(data.token);
    setEmail(data.email);
    return data;
  };
  const logout = () => { setToken(null); setEmail(null); };

  return (
    <AuthContext.Provider value={{ token, email, login, logout, isAuthed: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
